import React from 'react'
import "./featured.css"
const Featured = () => {
  return (
    <div className='parent'>
        <div className='tis'>
        <p className='his'>
            TOP SALE ON THIS WEEK
        </p>
        <h1>Featured Products</h1>
        <p className='lorum'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</p>
        </div>
    </div>
  )
}

export default Featured